import React, { useEffect } from "react";
import { Container, Button, } from "react-bootstrap";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { deleteProduct, getProductData, getSimpleCompleteProduct, updateProduct } from "./Product.action";
import { setHeading } from "../../../accounts/account.actions";
import MaterialTable from "material-table";


const ViewStoreProduct = (props) => {
  const permissions = JSON.parse(window.localStorage.getItem("permissions"))
  const Checkpermissions = (permissionsType, permissionsName) => {
    return permissions.some(p => p[`${permissionsType}`] === permissionsName) ? false : true
  }

  useEffect(() => {
    props.setHeading("Store Product List");
  }, []);

  return (
    <>
      <Container fluid>
        <div className="sendDiv">
          <Button onClick={() => { props.getCompleteProduct() }}>
            Generate Report
          </Button>
        </div>
        <MaterialTable
          title="Store Product Details"
          columns={[
            { title: 'Code', field: 'data.code', editable: 'never' },
            {
              title: "Product Name", field: "data.name",
              render: rowData =>
                <div style={{
                  backgroundColor: rowData.data.productTypeName == "Service Product" ? "transparent" : Number(rowData.data.productBalance) <= Number(rowData.data.minimumBalance) ? '#ff8d8d' : Number(rowData.data.productBalance) >= Number(rowData.data.maximumBalance) ? '#addfac' : 'transparent'
                }}> {rowData.data.name}</div>
            },
            { title: "UOM", field: "data.uomLabel", editable: 'never' },
            { title: "Product Balance", field: "data.productBalance", editable: 'never' },
            { title: "Product Purchase Price", field: "data.purchasePrice" },
            { title: "Minimum Balance", field: "data.minimumBalance", editable: 'never' },
            { title: "Maximum Balance", field: "data.maximumBalance", editable: 'never' },
            { title: "Amount", field: "amount", editable: 'never' },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/products/completeProduct?`;
              url += "limit=" + query.pageSize;
              url += "&page=" + (query.page);
              url += "&search=" + query.search;
              fetch(url, {
                method: 'GET',
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data1: result,
                  data: result.allData,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          options={{
            actionsColumnIndex: -1,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [20, 50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
            },
          }}
          editable={{
            isEditHidden: rowData => Checkpermissions("permissionsSubCatName", "Store Product Edit"),
            isDeleteHidden: rowData => Checkpermissions("permissionsSubCatName", "Store Product Delete"),
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.updateProduct(newData, oldData);
                }, 600);
              }),
            isDeletable: false,
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.deleteProduct(oldData._id);
                }, 600);
              }),
          }}
        />
      </Container>
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getProductData: () => dispatch(getProductData()),
    deleteProduct: (productId) => dispatch(deleteProduct(productId)),
    updateProduct: (newData, oldData) => dispatch(updateProduct(newData.data, oldData.data)),
    setHeading: (data) => dispatch(setHeading(data)),
    getCompleteProduct: () => dispatch(getSimpleCompleteProduct()),
  };
};
const mapStateToProps = (state, ownProps) => ({
  productDataList: state.ProductReducer.productDataList,
  isFetchingProduct: state.ProductReducer.isFetchingProduct,
  flavorsDataList: state.ColourReducer.flavorsDataList,
  sizeDataList: state.sizeReducer.sizeDataList,
  masterControlDataList: state.MasterControlReducer.masterControlDataList,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewStoreProduct);